var tagText = 'fx_c76f37be_lz3zmx1';
var tagTextColor = 'var(--fx_c76f37be_lz3zmx0)';

export { tagText, tagTextColor };
//# sourceMappingURL=text.vanilla.mjs.map
